import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { ScormAssessment, Scorm, ScormState } from '../types';

const initialState: ScormState = {
  scorm: undefined!,
  scormAssessment: undefined!,
};

const scormSlice = createSlice({
  name: 'scorm',
  initialState,
  reducers: {
    setScormAction(state, action: PayloadAction<Scorm>) {
      state.scorm = action.payload;
    },

    clearScormAction(state) {
      state.scorm = undefined!;
    },

    setScormAssessmentAction(state, action: PayloadAction<ScormAssessment>) {
      state.scormAssessment = action.payload;
    },

    clearScormAssessmentAction(state) {
      state.scormAssessment = undefined!;
    },
  },
});

export const { setScormAction, clearScormAction, setScormAssessmentAction, clearScormAssessmentAction } = scormSlice.actions;

export const getScorm = (state: RootState): ScormState => state.scorm;

export default scormSlice.reducer;
